export let EMPTY_PLACEHOLDER = 'Please answer this question'
export let STORAGE_KEY = 'PL'
export let STORAGE_KEY_IMAGE_CAPTURE = 'IC'
export let STORAGE_KEY_AUTH = 'AUTH'

export let FEE_MODE = /** @type {const} */ ({
  STANDARD: 'STANDARD',
  PLATFORM_FEE: 'PLATFORM_FEE',
  SURCHARGE: 'SURCHARGE',
})
